import apiService from '@api/apiService';
import i18n from '@config/i18n/i18n';

export default {
  get(slug) {
    return apiService.get(`${i18n.locale}/pages/${slug}`);
  }
}